import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const NewsletterSignup = ({ onSubscribe }) => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!email) return;

    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsSubscribed(true);
      setIsLoading(false);
      onSubscribe?.(email);
    }, 1500);
  };

  if (isSubscribed) {
    return (
      <div className="bg-gradient-to-br from-success/10 to-primary/5 border border-success/20 rounded-lg p-6 text-center animate-scale-in">
        <div className="w-12 h-12 bg-success/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircle" size={24} className="text-success" />
        </div>
        <h3 className="text-lg font-semibold text-card-foreground mb-2">
          Welcome to the Club!
        </h3>
        <p className="text-sm text-muted-foreground">
          You'll receive our curated collectibles insights directly in your inbox.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-primary/5 to-conversion-accent/5 border border-primary/20 rounded-lg p-6">
      <div className="text-center mb-4">
        <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-3">
          <Icon name="Mail" size={24} className="text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-card-foreground mb-2">
          Stay in the Know
        </h3>
        <p className="text-sm text-muted-foreground">
          Get weekly insights, market updates, and exclusive collecting tips delivered to your inbox.
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e?.target?.value)}
          required
          className="text-center"
        />
        
        <Button
          type="submit"
          variant="default"
          fullWidth
          loading={isLoading}
          iconName="ArrowRight"
          iconPosition="right"
        >
          Subscribe to Newsletter
        </Button>
      </form>
      <div className="flex items-center justify-center space-x-4 mt-4 pt-4 border-t border-border">
        <div className="flex items-center space-x-2 text-xs text-muted-foreground">
          <Icon name="Shield" size={14} />
          <span>No spam, ever</span>
        </div>
        <div className="flex items-center space-x-2 text-xs text-muted-foreground">
          <Icon name="Clock" size={14} />
          <span>Weekly digest</span>
        </div>
        <div className="flex items-center space-x-2 text-xs text-muted-foreground">
          <Icon name="X" size={14} />
          <span>Unsubscribe anytime</span>
        </div>
      </div>
    </div>
  );
};

export default NewsletterSignup;